import * as React from 'react';
import type { WrappedComponentProps } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import { FlagGroup, AutoDismissFlag } from '@atlaskit/flag';
import ErrorIcon from '@atlaskit/icon/core/cross-circle';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { AnalyticsContext } from '@atlassian/analytics-web-react';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import messages from './messages';

export interface RecaptchaFormErrorProps {
    onDismiss: () => void;
}

interface RecaptchaFormErrorState {
    displayFlag: boolean;
}

export class RecaptchaFormError extends React.PureComponent<
    RecaptchaFormErrorProps & WrappedComponentProps,
    RecaptchaFormErrorState
> {
    render() {
        const { intl, onDismiss } = this.props;
        const errorMessageTitle = intl.formatMessage(messages.loadErrorTitle);
        const errorMessageDescription = intl.formatMessage(messages.loadErrorDesc);

        return (
            <AnalyticsContext attributes={{ recaptchaError: 'load' }}>
                <>
                    <FlagGroup onDismissed={onDismiss}>
                        <AutoDismissFlag
                            id="recaptcha-fail-flag"
                            icon={
                                <ErrorIcon
                                    spacing="spacious"
                                    color={token('color.icon.danger', colors.R500)}
                                    label="error-with-recaptcha"
                                />
                            }
                            title={errorMessageTitle}
                            description={errorMessageDescription}
                        />
                    </FlagGroup>
                    <FireScreenEventOnMount />
                </>
            </AnalyticsContext>
        );
    }
}

export default injectIntl(RecaptchaFormError);
